import { render } from "./ClientManagementSearchFilters.vue?vue&type=template&id=2cf071c6&scoped=true"
import script from "./ClientManagementSearchFilters.vue?vue&type=script&lang=js"
export * from "./ClientManagementSearchFilters.vue?vue&type=script&lang=js"

import "./ClientManagementSearchFilters.vue?vue&type=style&index=0&id=2cf071c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf071c6"]])

export default __exports__